import _ from 'lodash';
import React from 'react';
import {
  Container, Row, Col, Button,
  Card, CardTitle, CardBody,
  Form, FormGroup, Label, Input,
} from 'reactstrap';

export function Login( props ) {
  return (
    <Container>
      <Row>
        <Col sm="9" md="7" lg="5" className="mx-auto">
          <h1>Swiper</h1>
          <Card className="card-signin my-5">
            <CardBody>
              <CardTitle className="text-center">Sign In</CardTitle>
              <Form className="form-signin">
                <FormGroup>
                  <Input
                    type="email"
                    id="inputEmail"
                    placeholder="Email address"
                    required
                  />
                  <Label for="inputEmail">Email Address</Label>
                </FormGroup>

                <FormGroup>
                  <Input
                    type="password"
                    id="inputPassword"
                    placeholder="Password"
                    required
                  />
                  <Label for="inputPassword">Password</Label>
                </FormGroup>

                <Button size="lg" color="primary" block type="submit">
                  Sign in
                </Button>
                <hr className="my-4" />
                {/*
                <Button size="lg" className="btn-google" block type="submit">
                  <Icon
                    icon="fab:google"
                    className="mr-2"
                    label="Sign in with Google"
                  />
                </Button>
                <Button size="lg" className="btn-facebook" block type="submit">
                  <Icon
                    icon="fab:facebook-f"
                    className="mr-2"
                    label="Sign in with Facebook"
                  />
                </Button>
                */}
              </Form>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}
